import { Observable, of } from 'rxjs'
import { environment } from '@exchange/environment'
import { HttpClient } from '@angular/common/http'
import { catchError } from 'rxjs/operators'
import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class OutboundDirectoryService {
  constructor(private httpClient: HttpClient) {}

  public fetchDirectories(): Observable<string[]> {
    const url = `${environment.blobapiroot}/FileShare/directories`

    return this.httpClient.get<string[]>(url).pipe(
      catchError(() => {
        return of([])
      })
    )
  }
}
